import { ApplicationFiltersNew, SortOptions } from 'types/campaign/applications';
import { RequirementDetails } from 'types/campaign/requirement';

export const defaultApplicationFilters: ApplicationFiltersNew = {
    declined: 'hide',
    page: 1,
    sort: SortOptions.RECOMMENDATION,
    bookmarked: 'n',
    q: '',
};

export const defaultShortlistedFilters: ApplicationFiltersNew = {
    ...defaultApplicationFilters,
    bookmarked: 'y',
};

const AUDIENCE_GENDER_THRESHOLD_DEFAULT = 50;
const AUDIENCE_CITIES_THRESHOLD_DEFAULT = 10;
const AUDIENCE_AGE_GROUPS_THRESHOLD_DEFAULT = 20;

export const getApplicationFiltersFromRequirements = (
    requirements?: RequirementDetails,
    base: ApplicationFiltersNew = defaultApplicationFilters
): ApplicationFiltersNew => {
    if (!requirements) return base;

    const filters: ApplicationFiltersNew = { ...base };

    if (requirements.gender && requirements.gender !== 'A') {
        filters.gender = requirements.gender;
    }

    if (requirements.age?.min > 0) {
        filters.age_min = requirements.age.min;
    }
    if (requirements.age?.max > 0) {
        filters.age_max = requirements.age.max;
    }

    if (requirements.follower_count?.min > 0) {
        filters.follower_count = requirements.follower_count.min;
    }

    if (requirements.average_views?.min > 0) {
        filters.average_views = requirements.average_views.min;
    }

    if (requirements.niches?.length) {
        filters.niches = requirements.niches.map(String);
    }

    if (requirements.speciality_niches?.length) {
        filters.speciality_niches = requirements.speciality_niches.map(String);
    }

    if (requirements.cities?.length) {
        filters.cities = [...requirements.cities];
    }

    if (requirements.regions?.length) {
        filters.regions = [...requirements.regions];
    }

    if (requirements.languages?.length) {
        filters.languages = requirements.languages.map(String);
    }

    if (requirements.topics?.length) {
        filters.topics = [...requirements.topics];
    }

    if (requirements.exclude_topics?.length) {
        filters.exclude_topics = [...requirements.exclude_topics];
    }

    if (requirements.audience_gender && requirements.audience_gender !== 'A') {
        filters.audience_gender = requirements.audience_gender;
        filters.audience_gender_threshold = AUDIENCE_GENDER_THRESHOLD_DEFAULT;
    }

    if (requirements.audience_cities?.length) {
        filters.audience_cities = [...requirements.audience_cities];
        filters.audience_cities_threshold = AUDIENCE_CITIES_THRESHOLD_DEFAULT;
    }

    if (requirements.audience_age_groups?.length) {
        filters.audience_age_groups = [...requirements.audience_age_groups];
        filters.audience_age_groups_threshold = AUDIENCE_AGE_GROUPS_THRESHOLD_DEFAULT;
    }

    return filters;
};
